import {
  CenterContainer,
  FlexibleRowContainer,
  LeftContainer,
} from "@coworker/app/src/components/RoomSettings/styles/styles";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";

export const SearchResultsSkeleton = () => {
  return (
    <FlexibleRowContainer
      data-testid="skeleton-list-item"
      style={{ padding: "20px 24px", background: "var(--white)" }}
    >
      <LeftContainer>
        <FixaSkeleton height={"48px"} width={"48px"} />
      </LeftContainer>
      <CenterContainer $centerText={false} style={{ gap: "5px" }}>
        <FixaSkeleton height={"14px"} width={"100%"} />
        <FixaSkeleton height={"14px"} width={"100%"} />
        <FixaSkeleton height={"14px"} width={"100%"} />
      </CenterContainer>
    </FlexibleRowContainer>
  );
};
